import { render, staticRenderFns } from "./PHxuansiji.vue?vue&type=template&id=5e701329&scoped=true&"
import script from "./PHxuansiji.vue?vue&type=script&lang=js&"
export * from "./PHxuansiji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e701329",
  null
  
)

export default component.exports